export const START_UP_DOCUMENT_LIST_QUERY_KEY = 'start-up-documents'
export const START_UP_DOCUMENT_QUERY_KEY = 'start-up-document'
